import { CHART_TYPES, type ChartType } from "../lib/chartTypes";
import { INDICATORS, type IndicatorKey } from "../lib/indicators";

interface ChartToolbarProps {
  chartType: ChartType;
  activeIndicators: IndicatorKey[];
  onChartTypeChange: (type: ChartType) => void;
  onAddIndicator: (indicator: IndicatorKey) => void;
  onReset: () => void;
}

export function ChartToolbar({
  chartType,
  activeIndicators,
  onChartTypeChange,
  onAddIndicator,
  onReset,
}: ChartToolbarProps) {
  return (
    <div className="chart-toolbar" aria-label="Chart display controls">
      <div className="chart-control">
        <label htmlFor="chartTypeSelect">Chart type</label>
        <select
          id="chartTypeSelect"
          className="chart-select"
          value={chartType}
          onChange={(event) => onChartTypeChange(event.target.value as ChartType)}
        >
          {CHART_TYPES.map((type) => (
            <option key={type.key} value={type.key}>
              {type.label}
            </option>
          ))}
        </select>
      </div>
      <div className="chart-control">
        <label htmlFor="indicatorSelect">Indicators</label>
        <select
          id="indicatorSelect"
          className="chart-select"
          value=""
          onChange={(event) => {
            if (event.target.value) {
              onAddIndicator(event.target.value as IndicatorKey);
            }
          }}
        >
          <option value="">Add indicator</option>
          {INDICATORS.map((indicator) => (
            <option
              key={indicator.key}
              value={indicator.key}
              disabled={activeIndicators.includes(indicator.key)}
            >
              {indicator.label}
            </option>
          ))}
        </select>
      </div>
      <button className="mini-button reset-chart-button" type="button" onClick={onReset}>
        Reset
      </button>
    </div>
  );
}
